export default __webpack_public_path__ + "static/media/OpenSans-Regular-webfont.4f6ec530.woff";